"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.playTurn = playTurn;
exports.playMoves = playMoves;
exports.rollDice = rollDice;
exports.getMovesWithSteps = getMovesWithSteps;
const lodash_1 = require("lodash");
const rules_1 = require("../rules");
function playTurn(model, moves) {
    if (model.gameState.state !== 'in-progress') {
        throw new Error('Game is not in progress');
    }
    // add current state to history
    const history = [...model.history, model.gameState];
    const rules = (0, rules_1.getRules)(model.rules);
    // calculate new state
    const stateWithMoves = rules.playTurnMoves(model.gameState, moves);
    if (rules.isGameOver(stateWithMoves)) {
        return Object.assign(Object.assign({}, model), { gameState: rules.getGameOverState(stateWithMoves), history });
    }
    // calculate next turn
    const nextTurnState = rules.finalizeTurn(stateWithMoves);
    return Object.assign(Object.assign({}, model), { gameState: nextTurnState, history });
}
function playMoves(model, moves, steps) {
    if (model.gameState.state !== 'in-progress') {
        throw new Error('Game is not in progress');
    }
    const rules = (0, rules_1.getRules)(model.rules);
    const newState = moves.reduce((s, m) => rules.playSingleMove(s, m), model.gameState);
    const newModel = Object.assign(Object.assign({}, model), { gameState: newState });
    const newSteps = rules.updateSteps(model.gameState, moves, steps);
    return {
        model: newModel,
        steps: newSteps,
    };
}
function rollDice(model) {
    if (model.gameState.state !== 'in-progress') {
        throw new Error('Game is not in progress');
    }
    if (!(0, lodash_1.isNil)(model.gameState.dice)) {
        throw new Error('Dice already rolled');
    }
    const rules = (0, rules_1.getRules)(model.rules);
    const newState = rules.rollDice(model.gameState);
    return Object.assign(Object.assign({}, model), { gameState: newState });
}
function getMovesWithSteps(model, steps) {
    if (model.gameState.state !== 'in-progress') {
        throw new Error('Game is not in progress');
    }
    const rules = (0, rules_1.getRules)(model.rules);
    return rules.getMovesWithSteps(model.gameState, steps);
}
